import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthProviderList, getUserAuthProviderList, userList } from '../../actions/users';
import { getUserId } from '../../helpers/session';
import AccessFormModal from '../Users/UserList/AccessFormModal';
import { Icon } from '../widgets';

const Oauth = () => {
    const [showModal, setShowModal] = useState(false)
    const [currentAuthId, setCurrentAuthId] = useState(null);

    const userId = getUserId();
    const providerListById = useSelector(state => state.users.authProviderListById.payload);
    const userInfo = useSelector(state => state.users.userListById.payload[userId]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUserAuthProviderList((authProvider) => {
            dispatch(userList([{
                user_id: userId,
                authList: authProvider
            }]));
        }));
        dispatch(getAuthProviderList());
    }, []);

    const handleAccessModal = (isShow, id) => {
        setShowModal(isShow);
        setCurrentAuthId(parseInt(id));
    }

    const getSortedAuthList = (list) => {
        const sortedAuthList = [...list]
        sortedAuthList.length > 0 && sortedAuthList.sort((a, b) => a.authentication_provider_id - b.authentication_provider_id);
        return sortedAuthList;
    }

    return (
        <>
            {userInfo && userInfo.authList && getSortedAuthList(userInfo.authList).map(item => {
                const iconName = ((providerListById[item.authentication_provider_id] || {}).authentication_provider_name || "").toLowerCase();
                if (!iconName) return null;
                const authIconUrl = require(`../../../assets/images/auth_${iconName}.png`);
                return <span key={item.authentication_provider_id} className="btn-icon access-img p-2">
                    <img src={authIconUrl} alt="" height="17px" width="17px"
                        onClick={() => handleAccessModal(true, item.authentication_provider_id)} />
                </span>
            })
            }
            <span className="btn-icon  mr-1 p-2">
                <Icon className="fa fa-ellipsis-h" onClick={() => setShowModal(true)}></Icon>
            </span>
            {showModal && <AccessFormModal
                userId={userId}
                currentAuthId={currentAuthId}
                providerListById={providerListById}
                onHide={() => handleAccessModal(false, null)}
            />}
        </>
    )
}

export default Oauth;